import { render, staticRenderFns } from "./StatusRadioButton.vue?vue&type=template&id=2c42fcb4&"
import script from "./StatusRadioButton.vue?vue&type=script&lang=js&"
export * from "./StatusRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports